import React, { Component } from "react";
import classNames from "classnames";
import Typical from "react-typical";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
import Menu from "@material-ui/icons/Menu";
// import Switch from "react-switch";
import Navbar from "components/Navbar.js"
import HeaderLinks from "components/HeaderLinks.js";

class Header extends Component {
  titles = [];

  constructor() {
    super();
    this.state = { checked: false };
    this.onThemeSwitchChange = this.onThemeSwitchChange.bind(this);
  }

  onThemeSwitchChange(checked) {
    this.setState({ checked });
    this.setTheme();
  }

  setTheme() {
    var dataThemeAttribute = "data-theme";
    var body = document.body;
    var newTheme =
      body.getAttribute(dataThemeAttribute) === "dark" ? "light" : "dark";
    body.setAttribute(dataThemeAttribute, newTheme);
  }

  render() {
    if (this.props.sharedData) {
      var name = "Hi, I'm a"
      this.titles = this.props.sharedData.titles.map(x => [ x.toUpperCase(), 1500 ] ).flat();
    }

    const HeaderTitleTypeAnimation = React.memo( () => {
      return <Typical className="title-styles" steps={this.titles} loop={50} />
    }, (props, prevProp) => true);

    return (
      <header id="home" style={{ height: window.innerHeight, display: 'block', zIndex: "11"}}>
        <div className="row aligner" style={{height: '75%'}}>
          <div className="col-md-12" >
            <div>
              <div style={{textAlign: "center"}}>
                <span className="iconify header-icon" data-icon="la:laptop-code" data-inline="false" ></span>
              </div>
              <br/>
              <h1 className="mb-0">
                <Typical steps={[name]} wrapper="p" />
              </h1>
              <div className="title-container" style={{textAlign: "center"}}>
                <HeaderTitleTypeAnimation />
              </div>
              <div style={{textAlign: "center"}}>
                <span key="github" className="m-4" style={{fontSize: '35px'}}>
                  <a href="https://github.com/hhdqirui" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-github" style={{color: 'white'}}></i>
                  </a>
                </span>
                <span key="linkedIn" className="m-4" style={{fontSize: '35px'}}>
                  <a href="https://www.linkedin.com/in/qirui-wu-6b4724205/" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin" style={{color: 'white'}}></i>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
